module.exports = __webpack_public_path__ + "img/sl-14.webp";